import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { useCanEditSuppliers } from '@client/components/suppliers/supplier-access';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { claimFormStore } from '../../../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New contact',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const { id, supplierId } = Route.useParams();
    const reload = claimFormStore.use.reload();
    const navigate = useNavigate();
    // CUR-2998: only someone who may change suppliers adds a contact to one; a direct link goes back.
    const canEditSuppliers = useCanEditSuppliers();

    useEffect(() => {
        if (isReadonly || !canEditSuppliers) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly, canEditSuppliers]);

    if (!canEditSuppliers) return null;

    return (
        <ContactEdit
            action={['add']}
            type="SUPPLIER"
            entity="supplier"
            entityId={supplierId}
            onSuccess={() => void reload()}
            claimId={id}
            showIsPrimaryForType={false}
        />
    );
}
